import { getType } from 'typesafe-actions';

import {
  donwloadExcelSettlement,
  donwloadPDFSettlement,
  getAllSettlements,
  getSettlementGroupingRules,
  getSettlementHistory,
  getTransactionSettlement,
  removeSettlement,
  setAggregatedSettlement,
  undoSettlementHistory,
} from './actions';
import {
  AggregatedTrade,
  SettlementGroupingRule,
  SettlementReport,
  TransactionSettlementResponse,
} from './types';

export interface SettlementState {
  groupingRules: {
    data: SettlementGroupingRule[];
    loading: boolean;
  };
  transactionSettlement: {
    data: TransactionSettlementResponse[];
    loading: boolean;
  };
  aggregatedSettlement: {
    loading: boolean;
    success: boolean;
  };
  historySettlement: {
    data: SettlementReport[];
    loading: boolean;
  };
  allSettlements: {
    data: AggregatedTrade[];
    loading: boolean;
  };
  donwloadExcelSettlement: {
    loading: boolean;
  };
  donwloadPDFSettlement: {
    loading: boolean;
  };
  removeSettlement: {
    loading: boolean;
  };
  undoHistory: {
    loading: boolean;
  };
}

const initialState: SettlementState = {
  groupingRules: {
    data: [],
    loading: false,
  },
  transactionSettlement: {
    data: [],
    loading: false,
  },
  aggregatedSettlement: {
    loading: false,
    success: false,
  },
  historySettlement: {
    data: [],
    loading: false,
  },
  allSettlements: {
    data: [],
    loading: false,
  },
  donwloadExcelSettlement: {
    loading: false,
  },
  donwloadPDFSettlement: {
    loading: false,
  },
  removeSettlement: {
    loading: false,
  },
  undoHistory: {
    loading: false,
  },
};

export const settlementReducer = (
  state = initialState,
  action: any,
): SettlementState => {
  switch (action.type) {
    // Grouping Rules
    case getType(getSettlementGroupingRules.request):
      return {
        ...state,
        groupingRules: {
          ...state.groupingRules,
          loading: true,
        },
      };

    case getType(getSettlementGroupingRules.success):
      return {
        ...state,
        groupingRules: {
          data: action.payload,
          loading: false,
        },
      };

    case getType(getSettlementGroupingRules.failure):
      return {
        ...state,
        groupingRules: {
          ...state.groupingRules,
          loading: false,
        },
      };

    // Transaction Settlement
    case getType(getTransactionSettlement.request):
      return {
        ...state,
        transactionSettlement: {
          ...state.transactionSettlement,
          loading: true,
        },
      };

    case getType(getTransactionSettlement.success):
      return {
        ...state,
        transactionSettlement: {
          data: action.payload,
          loading: false,
        },
      };

    case getType(getTransactionSettlement.failure):
      return {
        ...state,
        transactionSettlement: {
          ...state.transactionSettlement,
          loading: false,
        },
      };

    // Aggregated Settlement
    case getType(setAggregatedSettlement.request):
      return {
        ...state,
        aggregatedSettlement: {
          ...state.aggregatedSettlement,
          loading: true,
        },
      };

    case getType(setAggregatedSettlement.success):
      return {
        ...state,
        aggregatedSettlement: {
          loading: false,
          success: true,
        },
      };

    case getType(setAggregatedSettlement.failure):
      return {
        ...state,
        aggregatedSettlement: {
          ...state.aggregatedSettlement,
          loading: false,
        },
      };

    // History Settlement
    case getType(getSettlementHistory.request):
      return {
        ...state,
        historySettlement: {
          ...state.historySettlement,
          loading: true,
        },
      };

    case getType(getSettlementHistory.success):
      return {
        ...state,
        historySettlement: {
          data: action.payload,
          loading: false,
        },
      };

    case getType(getSettlementHistory.failure):
      return {
        ...state,
        historySettlement: {
          ...state.historySettlement,
          loading: false,
        },
      };

    // All Settlement
    case getType(getAllSettlements.request):
      return {
        ...state,
        allSettlements: {
          ...state.allSettlements,
          loading: true,
        },
      };

    case getType(getAllSettlements.success):
      return {
        ...state,
        allSettlements: {
          data: action.payload,
          loading: false,
        },
      };

    case getType(getAllSettlements.failure):
      return {
        ...state,
        allSettlements: {
          ...state.allSettlements,
          loading: false,
        },
      };

    // Download Excel
    case getType(donwloadExcelSettlement.request):
      return {
        ...state,
        donwloadExcelSettlement: {
          ...state.donwloadExcelSettlement,
          loading: true,
        },
      };

    case getType(donwloadExcelSettlement.success):
      return {
        ...state,
        donwloadExcelSettlement: {
          loading: false,
        },
      };

    case getType(donwloadExcelSettlement.failure):
      return {
        ...state,
        donwloadExcelSettlement: {
          ...state.donwloadExcelSettlement,
          loading: false,
        },
      };

    // Download PDF
    case getType(donwloadPDFSettlement.request):
      return {
        ...state,
        donwloadPDFSettlement: {
          ...state.donwloadPDFSettlement,
          loading: true,
        },
      };

    case getType(donwloadPDFSettlement.success):
      return {
        ...state,
        donwloadPDFSettlement: {
          loading: false,
        },
      };

    case getType(donwloadPDFSettlement.failure):
      return {
        ...state,
        donwloadPDFSettlement: {
          ...state.donwloadPDFSettlement,
          loading: false,
        },
      };

    // Remove Settlements
    case getType(removeSettlement.request):
      return {
        ...state,
        removeSettlement: {
          ...state.removeSettlement,
          loading: true,
        },
      };

    case getType(removeSettlement.success):
      return {
        ...state,
        removeSettlement: {
          loading: false,
        },
      };

    case getType(removeSettlement.failure):
      return {
        ...state,
        removeSettlement: {
          ...state.removeSettlement,
          loading: false,
        },
      };

    // Undo Settlement History
    case getType(undoSettlementHistory.request):
      return {
        ...state,
        undoHistory: {
          ...state.undoHistory,
          loading: true,
        },
      };

    case getType(undoSettlementHistory.success):
      return {
        ...state,
        undoHistory: {
          loading: false,
        },
      };

    case getType(undoSettlementHistory.failure):
      return {
        ...state,
        undoHistory: {
          ...state.undoHistory,
          loading: false,
        },
      };

    default:
      return state;
  }
};
